// extracted by mini-css-extract-plugin
export var content = "_42-3";
export var list = "_42-4";
export var settingsContent = "_42-7";
export var settingsPanel = "_42-8";
export var state = "_42-6";
export var triggerBadge = "_42-2";
export var triggerButton = "_42-1";
export var triggerShell = "_42-0";
export var unreadDot = "_42-5";